import React from "react";
import "./TestimonialSection.css";
import landingimg9 from "../../../../images/landing9.png";
import { FaQuoteLeft } from "react-icons/fa";

const TestimonialSection = () => {
  return (
    <section
      style={{
        background: `
          linear-gradient(
            0deg, 
            rgba(0, 0, 0, 0.45) 0%, 
            rgba(0, 0, 0, 0.45) 100%
          ), 
          url(${landingimg9}) center/cover no-repeat
        `,
      }}
      className="testimonial-section"
    >
      <div className="quote-icon">
        <FaQuoteLeft />
      </div>

      <h2 className="testimonial-heading">They speak about us…</h2>

      <p className="testimonial-text">
        “With Ebench, our hiring cycle reduced from 45 days to just 18 days. 
        The platform helped us connect with top candidates across Bengaluru, 
        Pune, and Hyderabad—without compromising on quality.”
      </p>

      <p className="testimonial-author">
        Divya Singh &nbsp; <span>Project Manager, Shilsha Technologies, India</span>
      </p>

      <button className="testimonial-btn">Read more testimonials</button>
    </section>
  );
};

export default TestimonialSection;
